<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { handleNext } from '../tutorialSteps'

const playerFlagsStore = usePlayerFlagsStore()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_colonizing_intro')
}

const isOnPlanetsSection = computed(() => {
  return route.path.startsWith('/map/galaxy')
})

const goToPlanets = () => {
  router.push('/map/galaxy')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/colonizing.webm"
  >
    <template #text>
      <p class="pb-2">
        Greetings!, I am your colonization advisor, responsible for helping you expand your empire across the stars.
      </p>
      <p class="pb-2">
        As we explore the galaxy together, I'll guide you in selecting the best worlds to colonize.
      </p>
    </template>

    <template #alerts>

    </template>

    <template #buttons>
      <ActionButton v-if="!isOnPlanetsSection" @click="goToPlanets" class="mr-2">
        Goto Map
      </ActionButton>
      <ActionButton @click="handleNextStep">
        Nice to meet you!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>